<template>
  <div>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
            <b-form-input type="text" disabled v-model="ipTrafficService.service_data.parent_id"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="serviceName" aria-describedby="inputFeedbackName" :state="validationName"/>
            <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="ipTrafficService.service_data.comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="suppliertList" v-model="selectSupplier"/>
          </b-form-group>
          <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
            <b-form-checkbox v-model="linkByDefault">{{ $t('Attach by default') }}</b-form-checkbox>
            <b-form-checkbox v-model="multipleLinking">{{ $t('Allow multiple linking') }}</b-form-checkbox>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('Service parameters')">
          <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="serviseCost" aria-describedby="inputFeedbackCost" :state="validationCost"/>
            <b-form-invalid-feedback id="inputFeedbackCost">
              {{ $t('Enter cost') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="chargeMethodList" v-model="selectChargeMethod"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="policyList" v-model="selectPolicy"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="schemeList" v-model="selectScheme">
              <template slot="first">
                <option :value=0>---</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="contractList" v-model="selectContract">
              <template slot="first">
                <option :value=0></option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Traffic aggregation period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-row>
              <b-col cols="8">
                <b-form-input type="number" v-model="ipTrafficService.iptraffic_service_data.aggregation_interval" :disabled="isDefault"/>
              </b-col>
              <b-col cols="4">
                <b-form-checkbox v-model="isDefault">{{ $t('Default') }}</b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Limit of simultaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="ipTrafficService.periodic_service_data.radius_sessions_limit"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Reset prepaid traffic')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox v-model="ipTrafficService.iptraffic_service_data.null_service_prepaid"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Dynamic IP address allocation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox v-model="isDynamic"/>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('Radius parameters')">
          <b-row>
            <b-col style="margin:5px">
              <b-button variant="success" @click="swohAddRadiusAttr">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnEditRadiusAttrButton(row)" id="transparent">
                <b-img :src='editImage'/>
              </b-button>
              <b-button size="sm" @click.stop="deleteRadiusAttr(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('Tariffication borders')">
          <b-row>
            <b-col style="margin:5px">
              <b-button variant="success" @click="showAddBorder">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="borderItems" :fields="borderFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnEditBorderButton(row)" id="transparent">
                <b-img :src='editImage'/>
              </b-button>
              <b-button size="sm" @click.stop="deleteBorder(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('Groups')" v-if="prepaymentItems.length === 0">
          <b-form-group label-align="right" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="groupList" v-model="selectGroup" :disabled="borderItems.length > 0"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-row>
              <b-col>
                <b-form-select :options="trafficClassesForGroupList" v-model="selectTrafficClassesFprGroup" :disabled="borderItems.length > 0"/>
              </b-col>
              <b-col>
                <b-button variant="success" @click="addTrafficClass" :disabled="borderItems.length > 0">{{ $t('Add') }}</b-button>
              </b-col>
            </b-row>
          </b-form-group>
          <b-table small striped hover :items="groupItems" :fields="groupFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="deleteTrafficClass(row)" id="transparent" :disabled="borderItems.length > 0">
                <b-img :src='deleteImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
        <b-tab :title="$t('Prepaid traffic')" v-if="groupItems.length === 0">
          <b-row>
            <b-col style="margin:5px">
              <b-button variant="success" @click="showAddPrepayment">{{ $t('Add') }}</b-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="prepaymentItems" :fields="prepaymentFields">
            <template v-slot:cell(actions)="row">
              <b-button size="sm" @click.stop="ClickOnEditPrepaymentButton(row)" id="transparent">
                <b-img :src='editImage'/>
              </b-button>
              <b-button size="sm" @click.stop="deletePrepayment(row)" id="transparent">
                <b-img :src='deleteImage'/>
              </b-button>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveIPtrafficService">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalServices">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Tariffication border')" ref="modalBorder">
      <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="trafficClassesList" v-model="selectTrafficClasses" :disabled="isEditBorder"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic volume')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="border.border"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="border.cost"/>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveBorder">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalBorder">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('Prepaid traffic')" ref="modalPrepayment">
      <b-form-group label-align="right" :label="$t('Traffic class')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="trafficClassesList" v-model="selectTrafficClasses" :disabled="isEditPrepayment"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic volume')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="prepayment.prepaid_unit"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Accumulate no more than')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="prepayment.prepaid_unitMax"/>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="savePrepayment">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalPrepayment">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    currentRowService: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      trafficClasses: [],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 3,
        'attrs': []
      },
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      border: {
        'border': 0,
        'cost': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      empertyBorder: {
        'border': 0,
        'cost': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      prepayment: {
        'prepaid_unit': 0,
        'prepaid_unitMax': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      empertyPrepayment: {
        'prepaid_unit': 0,
        'prepaid_unitMax': 0,
        'tcclassName': '',
        'tclass_id': 0
      },
      maxGroup: [],
      maxGroupClass: {
        'tclass_id': 0,
        'value': 0,
        'text': this.$i18n.t('TClass from max group'),
        'tcclassName': this.$i18n.t('TClass from max group')
      },
      groupItems: [],
      groupFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditPrepayment: false,
      prepaymentItems: [],
      prepaymentFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'prepaid_unit', label: this.$i18n.t('Traffic volume'), sortable: true},
        {key: 'prepaid_unitMax', label: this.$i18n.t('Accumulate no more than'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditBorder: false,
      borderItems: [],
      borderFields: [
        {key: 'tcclassName', label: this.$i18n.t('Traffic class'), sortable: true},
        {key: 'border', label: this.$i18n.t('Traffic volume'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost per byte'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isDefault: true,
      isDynamic: false,
      linkByDefault: true,
      multipleLinking: false,
      serviseCost: 0,
      serviceName: '',
      validationCost: true,
      validationName: false,
      selectTrafficClasses: 0,
      trafficClassesList: [],
      selectTrafficClassesFprGroup: 0,
      trafficClassesForGroupList: [],
      selectSupplier: 0,
      suppliertList: [],
      selectContract: 0,
      contractList: [],
      selectPolicy: 0,
      policyList: [],
      selectScheme: 0,
      schemeList: [],
      selectChargeMethod: 1,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      selectGroup: 1,
      groupList: [
        {text: 'max', value: 1},
        {text: 'sum', value: 2}
      ],
      editIPtrafficServices: null,
      ipTrafficService: {
        'iptraffic_service_data': {
          'aggregation_interval': 0,
          'borders': [],
          'null_service_prepaid': false,
          'prepaid': [],
          'service_id': 0,
          'tclass_id2group': []
        },
        'periodic_service_data': {
          'charge_method': 0,
          'cost': 0,
          'expire_date': 0,
          'have_tried_to_del': 0,
          'policy_id': 0,
          'radius_sessions_limit': 0,
          'scheme_id': 0,
          'service_id': 0
        },
        'service_data': {
          'comment': '',
          'contract_type': 0,
          'invoice_sup_id': 0,
          'is_dynamic': 0,
          'link_by_default': 0,
          'links_count': 0,
          'multiple_linking': 0,
          'parent_id': 0,
          'service_name': '',
          'tariff_id': 0
        }
      }
    }
  },
  methods: {
    async saveIPtrafficService () {
      if (!this.serviceName || !(this.serviseCost >= 0)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name or cost fields is invalid'), 'Error')
        return
      }
      if (this.ipTrafficService.iptraffic_service_data.aggregation_interval === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Traffic aggregation fields is invalid'), 'Error')
        return
      }
      if (this.ipTrafficService.periodic_service_data.radius_sessions_limit === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Limit of simultaneous sessions fields is invalid'), 'Error')
        return
      }
      let response
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.ipTrafficService.service_data.parent_id === 0) this.ipTrafficService.service_data.parent_id = -1
        this.linkByDefault ? this.ipTrafficService.service_data.link_by_default = 1 : this.ipTrafficService.service_data.link_by_default = 0
      }
      if (this.isTariffPlan) {
        this.ipTrafficService.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.isEdit) {
        this.ipTrafficService.service_data.tariff_id = this.editIPtrafficServices.service_data.tariff_id
      }
      this.ipTrafficService.service_data.service_name = this.serviceName
      this.ipTrafficService.periodic_service_data.cost = Number(this.serviseCost)
      this.ipTrafficService.periodic_service_data.charge_method = this.selectChargeMethod
      this.ipTrafficService.periodic_service_data.scheme_id = this.selectScheme
      this.ipTrafficService.service_data.contract_type = this.selectContract
      this.isDynamic ? this.ipTrafficService.service_data.is_dynamic = 1 : this.ipTrafficService.service_data.is_dynamic = 0
      if (this.isDefault) {
        this.ipTrafficService.iptraffic_service_data.aggregation_interval = 0
      } else {
        this.ipTrafficService.iptraffic_service_data.aggregation_interval = Number(this.ipTrafficService.iptraffic_service_data.aggregation_interval)
      }
      this.ipTrafficService.periodic_service_data.radius_sessions_limit = Number(this.ipTrafficService.periodic_service_data.radius_sessions_limit)
      this.ipTrafficService.iptraffic_service_data.borders = this.borderItems
      if (this.groupItems.length > 0 && this.selectGroup === 1) {
        if (this.borderItems.length) {
          this.ipTrafficService.iptraffic_service_data.borders = []
          let borderItemsGroupMax = this.borderItems.filter((value) => {
            return value.tclass_id === 0
          })
          for (let i in borderItemsGroupMax) {
            for (let j in this.groupItems) {
              let newBorder = JSON.parse(JSON.stringify(borderItemsGroupMax[i]))
              newBorder.tclass_id = this.groupItems[j].tclass_id
              this.ipTrafficService.iptraffic_service_data.borders.push(newBorder)
            }
          }
          let borderItems = this.borderItems.filter((value) => {
            return value.tclass_id !== 0
          })
          for (let i in borderItems) {
            this.ipTrafficService.iptraffic_service_data.borders.push(borderItems[i])
          }
        }
      }
      for (let i in this.prepaymentItems) {
        this.prepaymentItems[i].size = this.prepaymentItems[i].prepaid_unit
        this.prepaymentItems[i].size_max = this.prepaymentItems[i].prepaid_unitMax
        this.prepaymentItems[i].tclass = this.prepaymentItems[i].tclass_id
      }
      this.ipTrafficService.iptraffic_service_data.prepaid = this.prepaymentItems
      for (let i in this.groupItems) {
        this.groupItems[i].group_id = this.selectGroup
      }
      this.ipTrafficService.iptraffic_service_data.tclass_id2group = this.groupItems
      if (this.isEdit) {
        this.ipTrafficService.service_data.service_id = this.editIPtrafficServices.service_data.service_id
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_IPTRAFFIC, this.ipTrafficService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          }
        })
      } else {
        response = await axiosInstance.post(this.$store.getters.API_TARIFFING_SERVICES_IPTRAFFIC, this.ipTrafficService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
            return response.data.service_id
          }
        })
      }
      let suppId = {
        'service_id': 0,
        'invoice_sup_id': 0
      }
      if (this.isEdit) {
        suppId.service_id = this.editIPtrafficServices.service_data.service_id
      } else {
        suppId.service_id = response
      }
      suppId.invoice_sup_id = this.selectSupplier
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_SUPPLIER_ID, suppId)
      let policyId = {
        'service_id': 0,
        'policy_id': 0
      }
      if (this.isEdit) {
        policyId.service_id = this.editIPtrafficServices.service_data.service_id
      } else {
        policyId.service_id = response
      }
      policyId.policy_id = this.selectPolicy
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_CHRGE_POLICY, policyId)
      if ((this.isTemplates && this.multipleLinking) || (this.isTariffPlan && this.multipleLinking)) {
        let multiLink = {
          'service_id': 0,
          'multiple_linking': 0
        }
        if (this.isEdit) {
          multiLink.service_id = this.editIPtrafficServices.service_data.service_id
        } else {
          multiLink.service_id = response
        }
        multiLink.multiple_linking = 1
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_MULTI_LINKING, multiLink)
      }
      this.radiusAttr.attrs = this.radiusAttrItems
      if (this.isEdit) {
        this.radiusAttr.set_object_id = this.currentRowService.service_id
      } else {
        this.radiusAttr.set_object_id = response
      }
      axiosInstance.put(this.$store.getters.API_TARIFFING_RADIUS_ATTRS, this.radiusAttr)
    },
    async load () {
      let contractList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CONTRACT_TYPES).then(response => { return response.data })
      let suppliertList = await axiosInstance.get(this.$store.getters.API_TARIFFING_SUPPLIER).then(response => { return response.data })
      let policyList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CHARGE_POLICE).then(response => { return response.data })
      let schemeList = await axiosInstance.get(this.$store.getters.API_TARIFFING_COEFFICIENT_SCHEME).then(response => { return response.data })
      this.trafficClasses = await axiosInstance.get(this.$store.getters.API_TARIFFING_TCLASSES).then(response => { return response.data })
      for (let i in suppliertList) {
        suppliertList[i].value = suppliertList[i].id
        suppliertList[i].text = suppliertList[i].name
      }
      this.suppliertList = suppliertList
      for (let i in contractList) {
        contractList[i].value = contractList[i].id
        contractList[i].text = contractList[i].name
      }
      this.contractList = contractList
      for (let i in policyList) {
        policyList[i].value = policyList[i].policy_id
        policyList[i].text = policyList[i].name + ' (' + policyList[i].policy_id + ')'
      }
      this.policyList = policyList
      this.selectPolicy = this.policyList.length ? this.policyList[0].policy_id : null
      for (let i in schemeList) {
        schemeList[i].value = schemeList[i].id
        schemeList[i].text = schemeList[i].name
      }
      this.schemeList = schemeList
      for (let i in this.trafficClasses) {
        this.trafficClasses[i].value = this.trafficClasses[i].tclass_id
        this.trafficClasses[i].text = this.trafficClasses[i].name + ' (' + this.trafficClasses[i].tclass_id + ')'
      }
      this.trafficClassesList = this.trafficClasses
      this.selectTrafficClasses = this.trafficClassesList.length ? this.trafficClassesList[0].tclass_id : null
      this.trafficClassesForGroupList = JSON.parse(JSON.stringify(this.trafficClasses))
      this.selectTrafficClassesFprGroup = this.trafficClassesForGroupList[0].tclass_id
      if (this.isEdit || this.isTariffPlan) {
        this.editIPtrafficServices = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES_IPTRAFFIC + '?service_id=' + this.currentRowService.service_id).then(response => { return response.data })
        this.radiusAttrItems = await axiosInstance.get(this.$store.getters.API_TARIFFING_RADIUS_ATTRS + '?object_id=' + this.editIPtrafficServices.service_data.service_id + '&object_type=' + this.editIPtrafficServices.service_data.service_type).then(response => { return response.data })
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].tag) {
            this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          }
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
        this.serviseCost = this.editIPtrafficServices.periodic_service_data.cost
        this.serviceName = this.editIPtrafficServices.service_data.service_name
        this.ipTrafficService.service_data.comment = this.editIPtrafficServices.service_data.comment
        this.selectSupplier = this.editIPtrafficServices.service_data.invoice_sup_id
        this.selectContract = this.editIPtrafficServices.service_data.contract_type
        this.selectPolicy = this.editIPtrafficServices.periodic_service_data.policy_id
        this.selectScheme = this.editIPtrafficServices.periodic_service_data.scheme_id
        this.selectChargeMethod = this.editIPtrafficServices.periodic_service_data.charge_method
        this.ipTrafficService.periodic_service_data.radius_sessions_limit = this.editIPtrafficServices.periodic_service_data.radius_sessions_limit
        this.ipTrafficService.iptraffic_service_data.null_service_prepaid = this.editIPtrafficServices.iptraffic_service_data.null_service_prepaid
        if (this.editIPtrafficServices.service_data.is_dynamic === 1) this.isDynamic = true
        if (this.editIPtrafficServices.iptraffic_service_data.aggregation_interval) this.isDefault = false
        this.ipTrafficService.iptraffic_service_data.aggregation_interval = this.editIPtrafficServices.iptraffic_service_data.aggregation_interval
        if (!this.editIPtrafficServices.iptraffic_service_data.group2tf.length) {
          for (let curBorder of this.editIPtrafficServices.iptraffic_service_data.borders) {
            for (let curMap of curBorder.border_map) {
              curMap.tclass_id = curBorder.tclass_id
              this.borderItems.push(curMap)
            }
          }
        }
        if (this.editIPtrafficServices.iptraffic_service_data.group2tf.length === 0) {
          for (let i in this.editIPtrafficServices.iptraffic_service_data.prepaid) {
            if (this.editIPtrafficServices.iptraffic_service_data.prepaid[i].prepaid_unit) {
              this.prepaymentItems.push(this.editIPtrafficServices.iptraffic_service_data.prepaid[i])
            }
          }
          for (let i in this.editIPtrafficServices.iptraffic_service_data.prepaid_max) {
            for (let j in this.prepaymentItems) {
              if (this.editIPtrafficServices.iptraffic_service_data.prepaid_max[i].tclass_id === this.prepaymentItems[j].tclass_id) {
                this.prepaymentItems[j].prepaid_unitMax = this.editIPtrafficServices.iptraffic_service_data.prepaid_max[i].prepaid_unit
              }
            }
          }
          for (let i in this.prepaymentItems) {
            for (let j in this.trafficClasses) {
              if (this.prepaymentItems[i].tclass_id === this.trafficClasses[j].tclass_id) {
                this.prepaymentItems[i].tcclassName = this.trafficClasses[j].name + ' (' + this.trafficClasses[j].tclass_id + ')'
              }
            }
          }
        }
        if (this.editIPtrafficServices.iptraffic_service_data.group2tf.length) {
          this.selectGroup = this.editIPtrafficServices.iptraffic_service_data.group2tf[0].tariff_formula_type
        }
        for (let i in this.editIPtrafficServices.iptraffic_service_data.tclass_id2group) {
          this.groupItems.push(this.editIPtrafficServices.iptraffic_service_data.tclass_id2group[i])
        }
        for (let i in this.groupItems) {
          for (let j in this.trafficClasses) {
            if (this.groupItems[i].tclass_id === this.trafficClasses[j].tclass_id) {
              this.groupItems[i].tcclassName = this.trafficClasses[j].name + ' (' + this.trafficClasses[j].tclass_id + ')'
            }
          }
        }
        if (this.selectGroup === 2 && this.editIPtrafficServices.iptraffic_service_data.group2tf.length) {
          for (let i in this.editIPtrafficServices.iptraffic_service_data.borders) {
            for (let j in this.editIPtrafficServices.iptraffic_service_data.borders[i].border_map) {
              this.editIPtrafficServices.iptraffic_service_data.borders[i].border_map[j].tclass_id = this.editIPtrafficServices.iptraffic_service_data.borders[i].tclass_id
              this.borderItems.push(this.editIPtrafficServices.iptraffic_service_data.borders[i].border_map[j])
            }
          }
          for (let i in this.borderItems) {
            for (let j in this.trafficClasses) {
              if (this.borderItems[i].tclass_id === this.trafficClasses[j].tclass_id) {
                this.borderItems[i].tcclassName = this.trafficClasses[j].name + ' (' + this.trafficClasses[j].tclass_id + ')'
              }
            }
          }
        } else if (this.selectGroup === 1 && this.editIPtrafficServices.iptraffic_service_data.group2tf.length) {
          for (let i in this.editIPtrafficServices.iptraffic_service_data.borders) {
            for (let j in this.editIPtrafficServices.iptraffic_service_data.tclass_id2group) {
              if (this.editIPtrafficServices.iptraffic_service_data.borders[i].tclass_id === this.editIPtrafficServices.iptraffic_service_data.tclass_id2group[j].tclass_id) {
                this.maxGroup.push(this.editIPtrafficServices.iptraffic_service_data.borders[i])
              }
            }
          }
          for (let i in this.maxGroup[0].border_map) {
            this.maxGroup[0].border_map[i].tclass_id = 0
            this.maxGroup[0].border_map[i].tcclassName = this.maxGroupClass.tcclassName
            this.borderItems.push(this.maxGroup[0].border_map[i])
          }

          let borderItems = this.editIPtrafficServices.iptraffic_service_data.borders.filter((value) => {
            for (let curGroup of this.groupItems) {
              if (value.tclass_id === curGroup.tclass_id) {
                return false
              }
            }
            return true
          })
          for (let curBorder of borderItems) {
            for (let curMap of curBorder.border_map) {
              curMap.tclass_id = curBorder.tclass_id
              this.borderItems.push(curMap)
            }
          }
        }
        for (let i in this.borderItems) {
          for (let j in this.trafficClasses) {
            if (this.borderItems[i].tclass_id === this.trafficClasses[j].tclass_id) {
              this.borderItems[i].tcclassName = this.trafficClasses[j].name + ' (' + this.trafficClasses[j].tclass_id + ')'
            }
          }
        }
        if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
          this.ipTrafficService.service_data.parent_id = this.editIPtrafficServices.service_data.parent_id
          if (this.editIPtrafficServices.service_data.link_by_default === 1) {
            this.linkByDefault = true
          } else {
            this.linkByDefault = false
          }
          if (this.editIPtrafficServices.service_data.multiple_linking === 1) {
            this.multipleLinking = true
          } else {
            this.multipleLinking = false
          }
        }
      }
    },
    hideModalServices () {
      this.$emit('hideModalServices')
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    showAddBorder () {
      this.border = JSON.parse(JSON.stringify(this.empertyBorder))
      this.isEditBorder = false
      this.$refs.modalBorder.show()
    },
    ClickOnEditBorderButton (row) {
      this.border = row.item
      this.selectTrafficClasses = this.border.tclass_id
      this.isEditBorder = true
      this.$refs.modalBorder.show()
    },
    deleteBorder (row) {
      this.borderItems = this.borderItems.filter((value) => {
        return value !== row.item
      })
    },
    hideModalBorder () {
      this.$refs.modalBorder.hide()
    },
    saveBorder () {
      if (!this.border.cost) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error cost format'), 'Error')
        return
      }
      if (!this.border.border) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error border format'), 'Error')
        return
      }
      if (this.selectGroup === 1) {
        for (let i in this.groupItems) {
          if (this.groupItems[i].tclass_id === this.selectTrafficClasses) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This TClass is already used in max group'), 'Error')
            return
          }
        }
      }
      this.border.border = Number(this.border.border)
      this.border.cost = Number(this.border.cost)
      this.border.tclass_id = this.selectTrafficClasses
      for (let i in this.trafficClasses) {
        if (this.trafficClasses[i].tclass_id === this.border.tclass_id) {
          this.border.tcclassName = this.trafficClasses[i].name + ' (' + this.trafficClasses[i].tclass_id + ')'
          break
        }
      }
      if (this.selectGroup === 1 && this.selectTrafficClasses === 0) {
        this.border.tcclassName = this.maxGroupClass.tcclassName
      }
      if (!this.isEditBorder) {
        this.borderItems.push(this.border)
      }
      this.hideModalBorder()
    },
    showAddPrepayment () {
      this.prepayment = JSON.parse(JSON.stringify(this.empertyPrepayment))
      this.isEditPrepayment = false
      this.$refs.modalPrepayment.show()
    },
    ClickOnEditPrepaymentButton (row) {
      this.prepayment = row.item
      this.isEditPrepayment = true
      this.$refs.modalPrepayment.show()
    },
    deletePrepayment (row) {
      this.prepaymentItems = this.prepaymentItems.filter((value) => {
        return value !== row.item
      })
    },
    hideModalPrepayment () {
      this.$refs.modalPrepayment.hide()
    },
    savePrepayment () {
      if (!this.prepayment.prepaid_unit) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error cost format'), 'Error')
        return
      }
      if (!this.prepayment.prepaid_unitMax) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Error border format'), 'Error')
        return
      }
      if (!this.isEditPrepayment) {
        for (let i in this.prepaymentItems) {
          if (this.prepaymentItems[i].tclass_id === this.selectTrafficClasses) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt add one more prepaid traffic for tclass'), 'Error')
            return
          }
        }
      }
      this.prepayment.prepaid_unit = Number(this.prepayment.prepaid_unit)
      this.prepayment.prepaid_unitMax = Number(this.prepayment.prepaid_unitMax)
      this.prepayment.tclass_id = this.selectTrafficClasses
      for (let i in this.trafficClasses) {
        if (this.trafficClasses[i].tclass_id === this.prepayment.tclass_id) {
          this.prepayment.tcclassName = this.trafficClasses[i].name + ' (' + this.trafficClasses[i].tclass_id + ')'
          break
        }
      }
      if (!this.isEditPrepayment) {
        this.prepaymentItems.push(this.prepayment)
      }
      this.hideModalPrepayment()
    },
    addTrafficClass () {
      for (let i in this.groupItems) {
        if (this.groupItems[i].tclass_id === this.selectTrafficClassesFprGroup) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt add one more prepaid traffic for tclass'), 'Error')
          return
        }
      }
      let newTrafficInGroup = {
        'tclass_id': 0,
        'group_id': 0,
        'tcclassName': ''
      }
      newTrafficInGroup.tclass_id = this.selectTrafficClassesFprGroup
      for (let i in this.trafficClasses) {
        if (this.trafficClasses[i].tclass_id === newTrafficInGroup.tclass_id) {
          newTrafficInGroup.tcclassName = this.trafficClasses[i].name + ' (' + this.trafficClasses[i].tclass_id + ')'
          break
        }
      }
      this.groupItems.push(newTrafficInGroup)
    },
    deleteTrafficClass (row) {
      this.groupItems = this.groupItems.filter((value) => {
        return value !== row.item
      })
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    serviceName: function (val) {
      if (val.length) {
        this.validationName = true
      } else {
        this.validationName = false
      }
    },
    serviseCost: function (val) {
      if (val >= 0) {
        this.validationCost = true
      } else {
        this.validationCost = false
      }
    },
    groupItems: function (val) {
      if (val.length > 0 && this.selectGroup === 1) {
        let maxGroupClass = this.trafficClassesList.find(el => {
          return el.tclass_id === 0
        })
        if (!maxGroupClass) {
          this.trafficClassesList.push(this.maxGroupClass)
        }
      } else {
        this.trafficClassesList = this.trafficClassesList.filter((value) => {
          return value.tclass_id !== 0
        })
        this.selectTrafficClasses = this.trafficClassesList[0].tclass_id
      }
    },
    selectGroup: function (val) {
      if (this.selectGroup === 2) {
        this.trafficClassesList = this.trafficClassesList.filter((value) => {
          return value.tclass_id !== 0
        })
        this.selectTrafficClasses = this.trafficClassesList[0].tclass_id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formIPtrafficService.vue